<ngx-dynamic-hooks [content]="content"></ngx-dynamic-hooks>
